module.exports = __webpack_public_path__ + "static/adventcalendarbannerdesktop-57366a2a55795822beb526273b6383b2.gif";